export default __webpack_public_path__ + "static/media/elabs_logo.f8fd724c.png";